// extracted by mini-css-extract-plugin
export default {"socialIconsList":"SocialIconsList_socialIconsList__6BeJz"};